import React from 'react';
import { motion } from 'framer-motion';
import './UpcomingProjects.css';

const UpcomingProjects = () => {
  const upcomingProjects = [
    {
      id: 1,
      title: 'AI-Driven Career Roadmap and Recruitment Readiness Portal for Computer Science Professionals',
      description: 'Building a unified platform to bridge the gap between academic curriculum and industry requirements. The platform addresses critical challenges: skill gap & guidance void by highlighting hot topics and industry trends, high ATS rejection rates through resume optimization, and fragmented learning ecosystems. Features include personalized career roadmaps, salary impact analysis for skills, ATS-friendly resume analysis, and integrated course recommendations. Aims to provide a free, data-driven solution for Computer Science graduates and freshers.',
      tech: ['MongoDB', 'Express.js', 'React', 'Node.js', 'AI/ML APIs'],
      status: 'In Planning',
      progress: 15,
      image: '🚀',
      expectedCompletion: 'February 2026',
    },
    {
      id: 2,
      title: 'Jenkins Project: Building CI/CD Pipeline for Scalable Web Applications',
      description: 'Learning to leverage Jenkins, Docker, Kubernetes, and Amazon EKS to create robust, scalable, and automated CI/CD pipelines for applications. This project focuses on implementing continuous integration and continuous deployment workflows, containerization strategies, and orchestration on cloud infrastructure to streamline development and deployment processes.',
      tech: ['Jenkins', 'Docker', 'Kubernetes', 'Amazon EKS', 'CI/CD'],
      status: 'In Planning',
      progress: 10,
      image: '⚙️',
      expectedCompletion: 'March 2026',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const cardVariants = {
    hidden: { x: -100, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.8, ease: 'easeOut' },
    },
  };

  return (
    <div className="upcoming-projects">
      <div className="upcoming-container">
        <motion.div
          className="upcoming-header"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">
            Upcoming <span className="gradient-text">Projects</span>
          </h1>
          <div className="title-underline"></div>
          <p className="page-description">
            Exciting projects currently in development and planning phase
          </p>
        </motion.div>

        <motion.div
          className="upcoming-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {upcomingProjects.map((project, index) => (
            <motion.div
              key={project.id}
              className="upcoming-card"
              variants={cardVariants}
              whileHover={{ scale: 1.02, y: -5 }}
              transition={{ duration: 0.3 }}
            >
              <div className="upcoming-badge">
                <span className="status-indicator"></span>
                {project.status}
              </div>
              
              <div className="upcoming-content-wrapper">
                <div className="upcoming-icon-section">
                  <div className="upcoming-icon">{project.image}</div>
                </div>
                
                <div className="upcoming-details">
                  <h3 className="upcoming-title">{project.title}</h3>
                  <p className="upcoming-description">{project.description}</p>
                  
                  <div className="progress-section">
                    <div className="progress-header">
                      <span>Progress</span>
                      <span className="progress-percentage">{project.progress}%</span>
                    </div>
                    <div className="progress-bar">
                      <motion.div
                        className="progress-fill"
                        initial={{ width: 0 }}
                        animate={{ width: `${project.progress}%` }}
                        transition={{ duration: 1, delay: index * 0.3 }}
                      ></motion.div>
                    </div>
                  </div>

                  <div className="upcoming-tech">
                    {project.tech.map((tech, idx) => (
                      <span key={idx} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>

                  <div className="completion-date">
                    <span className="date-icon">📅</span>
                    Expected: {project.expectedCompletion}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="cta-section"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
        >
          <h2>Stay Updated!</h2>
          <p>Follow my journey as I build these exciting projects</p>
        </motion.div>
      </div>
    </div>
  );
};

export default UpcomingProjects;
